import { useStrings } from "@1js/localization-components";
import {
  MessageBar,
  MessageBarBody,
  MessageBarTitle,
} from "@fluentui/react-components";
import * as React from "react";
import {
  PromptGridTeamsAnnouncementDescription,
  PromptGridTeamsAnnouncementHeader,
} from "./PromptResultsAnnouncement.strings";

export const PromptTeamNotice: React.FC = () => {
  const localization = useStrings({
    PromptGridTeamsAnnouncementHeader,
    PromptGridTeamsAnnouncementDescription,
  });

  return (
    <div style={{ paddingBottom: "20px" }}>
      <MessageBar>
        <MessageBarBody>
          <MessageBarTitle>
            {localization.PromptGridTeamsAnnouncementHeader()}
          </MessageBarTitle>
          {localization.PromptGridTeamsAnnouncementDescription()}
        </MessageBarBody>
      </MessageBar>
    </div>
  );
};
